import { XHR } from '@wsb/guac-widget-shared/lib/common/ols-core/shop-bundle';
import { OlsConfigStore } from '@wsb/guac-widget-shared/lib/common/ols-core/core-bundle';

function getBaseUrl() {
  return OlsConfigStore.getApiBaseUrl();
}

export function subscribeToOpenStore(email) {
  return XHR.postRequest(`${getBaseUrl()}/api/v1/prospective_customers`, {
    prospective_customer: { email: email }
  });
}
